//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <DIV class='content-wrapper'>
  <div v-if="serverData.loadingDataStatus.mainCommonData != serverData.loadingDataStatus.types.LOADED" class="loading-text">
    Подождите, загружаются общие данные
  </div>
  <div v-else-if="serverData.loadingDataStatus.users != serverData.loadingDataStatus.types.LOADED" class="loading-text">
    Подождите, загружаются данные по пользователям
  </div>
  <div v-else-if="user == null" style="width:100%; float:left">
    <div @click="close()"><i class="fas fa-arrow-circle-left back-button"></i></div>
    <div v-if="activeUser == null" class="usernotfound-text">Информация недоступна. Войдите в приложение</div>
    <div v-else class="usernotfound-text">Пользователь не найден</div>
  </div>
  <div v-else class="user">

    <div class="user-avatar" :style="{'background-image': 'url(' + serverData.imagesGetURL(user.body.avatar) + ')'}" @click="close()">
      <i class="fas fa-arrow-circle-left back-button-over"></i>
    </div>

    <div style="width:100%; padding:10px 0 0 0; float:left;">
      <div class="user-name">{{user.name}}</div>
    </div>
    <div style="width:100%; padding:10px 0 0 0; float:left;">
      <div class="user-prop">{{serverData.appSettings.common.userGroupsMap[user.group].memberName}}</div>
    </div>
    <div v-if="isActiveUserAdmin()" style="width:100%; padding:10px 0 0 0; float:left;">
      <div class="user-prop">+{{user.phone}}</div>
    </div>
    <div style="width:100%; padding:10px 0 0 0; float:left;">
      <div class="user-prop-small">Зарегистрирован: {{user.createdAt | formatDate('monthAsWord')}}</div>
    </div>
    <div v-if="user.deleted != 0" style="width:100%; padding:10px 0 0 0; float:left;">
      <div class="user-prop">Удален</div>
    </div>

  </div>

  </DIV>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters } from 'vuex'

import http from 'axios'

import serverData from '@/store/serverData'

// import restResource from '@/technical/restResource'
import serverErrorHandling from '@/technical/serverErrorHandling'

export default {
  components: { },
  props: ['id'],
  data () {
    return {
      userId: null,
      user: null,
      serverData: serverData, // to make access from UI template
      loadingSpinner: false
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'activeUser'
    ])
  },
  created: function () {
    var thisRef = this
    // загружаем данные, когда представление создано и данные реактивно отслеживаются
    this.getUserData()
    // подписываемся на загрузку основных данных - когда эта страница это та на которой стартует приложение и на момент created данные еще не подгрузились
    serverData.eventsBus.$on('mainCommonDataLoaded', this.getUserData)
    // на realtime обновления users подписываемся на случай если кто-то обновил именно этого пользователя
    serverData.eventsBus.$on('usersChanged', function (data) {
      // вызов этого обработчика будет и пока грузятся основные данные через mainCommonDataLoader что уже обрабатывается
      // через подписку на $on('mainCommonDataLoaded') и второй обработки users нам не надо
      if (data.initiator === 'realtimeServerDataManager') thisRef.getUserData(data)
    })
  },
  watch: {
    // при изменениях маршрута запрашиваем данные снова. а если сначала смотрели /event/1, ушли, и снова смотрим но /event/2 то кроме как через watch route больше об этом не узнать
    // !!!!!! И ВАЖНО ПОМНИТЬ: этот роутер будет вызываться вообще всегда даже когда ходишь по эвентам. поэтому проверку надо на router.path иrouter.name
    $route: 'getUserData'
  },
  methods: {
    // data - это может быть объект из realtimeServerDataManager {method:'update', record:{id, name...}, initiator: "realtimeServerDataManager"}
    // а может быть объект route из watch route. пример = {name:'place', path:'/place/1', params:{id:1}}
    getUserData (data) {
      if ((data != null) && (data.path != null) && (data.name !== 'user')) return // на случай если это вызов через watch route когда ушли со страницы
      if ((data != null) && (data.record != null) && (data.record.id !== this.userId)) return // на случай если пришло через realtimeServerDataManager обновление но объект с другим id
      // console.log('getUserData')
      // проверка что данные уже загружены в serverData, а то страница когда первая то сначала сюда, а потом данные догружаются,
      // не надо спешить с отдельным запросом на сервер, может и в getTimeline придет пользователь
      if (serverData.loadingDataStatus.users !== serverData.loadingDataStatus.types.LOADED) return
      var thisRef = this
      this.userId = this.id
      if (typeof this.userId === 'string') this.userId = parseInt(this.userId)
      var anUser = serverData.usersMap[this.userId]
      if (anUser != null) {
        this.user = Object.assign({}, anUser)
        // this.user.body = Object.assign({}, anUser.body)
      } else {
        if (this.activeUser == null) return // если не залогинен то можно к серверу и не обращаться, вернет на запрос о пользователе 403. для незалогиненных доступны юзеры только из timeline
        http.get(this.appSettings.server.userResource + '/' + this.userId)
        .then(function (response) {
          var anUser = response.data[0]
          if (anUser == null) return // нет такого пользователя
          thisRef.userId = anUser.id
          serverData.users.push(anUser)
          serverData.usersMap[thisRef.userId] = anUser
          thisRef.user = Object.assign({}, anUser)
          // thisRef.user.body = Object.assign({}, anUser.body)
          // if (anUser.body.avatar != null) thisRef.fileEntitiesMapCreateOne(anUser.body.avatar)
        })
        .catch(function (error) {
          serverErrorHandling(error, thisRef)
        })
      }
    },
    isActiveUserAdmin () {
      if ((this.activeUser != null) && ((this.activeUser.group === 0) || (this.activeUser.group === 1))) return true // суперпользователь или админ
      return false
    },
    close () {
      // 2 - это значит пустая страница + текущая с продуктом. или 1 - сразу из внешнего приложения открылась эта страница
      if (history.length <= 2) window.location.href = '/' // !!! проверить
      else history.back() // this.$router.go(-1)
    }
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  width: 100%;
  margin: 0px 0px 0px 0px;
  padding: 0px;
  font-family: "Open Sans", sans-serif;
  font-weight: 100;
}
.back-button {
  width: 100%;
  font-size: 35px;
  color: #777;
  padding: 10px 10px 10px 15px;
  cursor: pointer;
  float: left;
}
.back-button-over {
  width: 50px;
  position: relative;
  top: 10px;
  left: 7px;
  font-size: 35px;
  color: #888;
  cursor: pointer;
  float: left;
}
.loading-text {
  font-family: "Open Sans", sans-serif;
  font-weight: 100;
  font-size: 20px;
  padding: 20px 20px 20px 20px;
}
.usernotfound-text {
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  font-size: 20px;
  padding: 20px 20px 20px 20px;
}
.user {
  width: 80%;
  margin: 25px 10% 0 10%;
  padding-bottom: 40px;
  text-align: center;
  float:left;
}
.user-avatar {
  width: 80vw;
  height: 80vw;
  background: #333;
  background-size: cover;
  background-position: center;
  border-radius: 40vw;
  border: solid 1px #e0e0e0;
  cursor: pointer;
  float: left;
}
@media screen and (min-width: 500px) {
  .user {
    width: 450px;
    margin-left: calc((100% - 450px) / 2);
  }
  .user-avatar {
    width: 450px;
    height: 450px;
    border-radius: 225px;
  }
}
.user-name {
  /* top: calc(100% - 105px); */
  /* position: relative;
  top: calc(100% - 120px);
  left: calc(15% - 20px);
  width: calc(70% - 40px);
  padding: 20px 20px 20px 20px;
  opacity: 1.0; */
  width: 100%;
  padding: 7px 25px 0px 25px;
  background: #fff;
  color: #000;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
  border-right: solid 0px #000;
  border-radius: 10px 10px 10px 10px;
  float:left;
}
.user-prop {
  width: 100%;
  padding: 7px 25px 0px 25px;
  color: #666;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 15px;
  float:left;
}
.user-prop-small {
  width: 100%;
  padding: 7px 25px 0px 25px;
  color: #666;
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  font-size: 10px;
  float:left;
}
.text-align-left {
  text-align:left;
}
.text-align-right {
  text-align:right;
}
.button-primary{
  margin: 20px 4.5% 20px 4.5%;
  /*background: #6770a6;*/
  border-radius: 15px;
  background: #6070dd;
  font-size: 16px;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// User.vue?eae3bff4